import { t } from "i18next";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useFetch } from "../../../../hooks/useFetch";
import { Button } from "../../../../ui/Button";
import { Label } from "../../../../ui/Label/Label";
import { SelectButton } from "../../../../ui/SelectButton/SelectButton";
import { DatePicker } from "../../../../ui/Datepicker/DatePicker";
import { useAppStore } from "../../../../stores/RootStore";

type Props = {
  itemId: string | undefined;
  refreshModels: Function;
};

const AddStaffDivision = ({ itemId, refreshModels }: Props) => {
  const personsData = useAppStore((store) => store.persons)!;
  const persons = personsData.map((person) => {
    return {
      value: person.id,
      label: person.attributes.middle_name
        ? `${person.attributes.last_name} ${person.attributes.first_name} ${person.attributes.middle_name}`
        : `${person.attributes.last_name} ${person.attributes.first_name}`,
    };
  });

  const [personId, setPersonId] = useState("");

  const [errors, setErrors] = useState([]);
  const { watch, handleSubmit, control } = useForm({});

  const [{ response: saveChangeResponse, isLoading: saveChangeIsLoading, error: saveChangeError }, doFetchSaveChange] =
    useFetch(`/directories/personnels/${personId}/changes`);

  useEffect(() => {
    if (!personId) return;
    doFetchSaveChange({
      method: "POST",
      data: {
        data: {
          division_id: itemId,
          at: new Date(),
        },
      },
    });
  }, [personId]);

  useEffect(() => {
    if (saveChangeResponse) {
      refreshModels();
    }
  }, [saveChangeResponse]);

  const onSubmit = (formData: any) => {
    setPersonId(formData.staff);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="px-6">
      <div className="flex flex-col w-full gap-1 bg-muted p-4 rounded">
        <div className="text-lg font-medium">{t("adding_staff")}</div>
        <div className="text-sm">Выберите сотрудника для добавления в подразделение</div>

        <div className="flex w-full items-center gap-4 mt-4">
          <div className="flex w-full">
            <Controller
              name="staff"
              control={control}
              render={({ field: { value, onChange } }) => (
                <div className="relative flex w-full">
                  <SelectButton
                    label={"Выберите сотрудника"}
                    searchable={true}
                    options={persons}
                    value={value ? persons.find((s) => s.value == String(value))! : null}
                    onChange={(e) => onChange(e?.value)}
                  />
                </div>
              )}
            />
          </div>
          <Button type="submit" size={"sm"} disabled={watch('staff') ? false : true}>
            {t("add")}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default AddStaffDivision;
